/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";
import { TokenStorage } from "../../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const TaxCategoryService = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(code) {
    const requestScreenData = {
      url: "api/Tax",
      top: "1",
      filter: `Code eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getDefault() {
    const requestScreenData = {
      url: "api/Tax",
      top: "1",
      filter: `IsDefault eq 'Y'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async save(mode, Tax) {
    var payload = Tax;
    var url = "api/Tax";

    if (mode == "create") {
      return await ApiService.post(url, payload, "String");
    } else {
      return await ApiService.patch(url, Tax.Code, payload, "String");
    }
  },
};

export { TaxCategoryService };
